import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { graphql } from 'gatsby'
import { Container, Section, Row, RowColumn } from 'chaoskit/src/components'
import { MDXRenderer } from 'gatsby-plugin-mdx'

import HelmetSEO from '~partials/global/HelmetSEO'
import SecurityLayout from '~layouts/SecurityLayout'
import TableOfContents from '~components/TableOfContents'

const SecurityPractices = ({
  data: {
    file: {
      childMdx: { tableOfContents, body, frontmatter: pageData },
    },
  },
}) => {
  const theme = useTheme()

  return (
    <SecurityLayout title={pageData.title}>
      <HelmetSEO title={pageData.title} description={pageData.description} />

      <Section>
        <Container>
          <Row gutter={{ base: 'large' }}>
            <RowColumn
              size={{ medium: 3 }}
              css={{
                [theme.mq.small__max]: {
                  display: 'none',
                },
              }}
            >
              <TableOfContents tree={tableOfContents} />
            </RowColumn>
            <RowColumn
              size={{ medium: 9 }}
              css={{
                h2: {
                  ...theme.text['3xlarge__fluid'],
                },
                h3: {
                  ...theme.text['2xlarge__fluid'],
                },
              }}
            >
              <MDXRenderer>{body}</MDXRenderer>
            </RowColumn>
          </Row>
        </Container>
      </Section>
    </SecurityLayout>
  )
}

SecurityPractices.propTypes = {
  data: PropTypes.object.isRequired,
}

export default SecurityPractices

export const pageQuery = graphql`
  query SecurityPracticesPageData {
    file(
      name: { eq: "security__practices" }
      absolutePath: { regex: "/src/data/" }
    ) {
      childMdx {
        body
        tableOfContents
        frontmatter {
          title
          description
          hero {
            heading
          }
        }
      }
    }
  }
`
